/**************************************************
 * Nombre:       Tarjeta_Productos_Escogidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjeta_Productos_Escogidos = ({item, click}) => {

    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{

                border: 1,
                borderColor: theme.palette.primary.main + 50,
                borderRadius: 2,
                overflow: 'hidden',
            }}
        >

            <Grid
                onClick={() => click(item)}
                container size={3} sx={{justifyContent: 'flex-start', cursor: 'pointer'}}>
                <img src={item.img} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={9}
                sx={{
                    py: 1,
                    px: 2
                }}
            >

                <Grid container size={1} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>{item.cantidad}</Typography>
                </Grid>

                <Grid container size={9} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 400}}>{item.nombre}</Typography>
                </Grid>


                <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{fontWeight: 800}}>{item.codigo}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>{`Valor Unit: ${formatoMonedaTabla(item.valor)}`}
                        <span style={{
                            fontWeight: 600,
                            marginLeft: 5
                        }}>{` (x${item.cantidad}) ${formatoMonedaTabla(item.valor * item.cantidad)}`}</span>
                    </Typography>
                </Grid>

                <Grid container size={9} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12, fontWeight: 600}}>{`Notas: ${item.notas ? item.notas : ''}`}
                    </Typography>
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-end', mb: -2, mt: 1.5}}>

                    {item.estado === 'Listo' ?

                        <Button sx={{px: 1, py: 0.2}}>
                            Entregar
                        </Button> :

                        <Typography>{item.estado}</Typography>

                    }
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Productos_Escogidos    